module.exports = __webpack_public_path__ + "img/SLV.dd314305.svg";